export default __webpack_public_path__ + "static/media/office.c0365e6f.png";